export enum UrlsRoles {
  VIEWER = 'roles.urlsViewer',
  PERSISTER = 'roles.urlsPersister',
  DELETER = 'roles.urlsDeleter',
}
